module.exports = __webpack_public_path__ + "static/media/aiva_ai.637bcc5e.png";